export default __webpack_public_path__ + "static/media/19-LochNessDonut.13adbd61.png";